import { Route } from 'types/route.type';
import ListOrderSupplyPlan from './my-supply-plan';

export const routes: Route[] = [
  {
    path: '/order-feed/supply-plan/:siteErpId?/:globalSiteId?',
    component: ListOrderSupplyPlan,
    id: 'orderFeed.navigation.orderSupplyPlan',
  },
];
